import { t } from 'i18next'
import { GrView } from 'react-icons/gr'

export const ViewButtonHandlerTask = ({ buttons, crudContext }) => {
    buttons.view = {
        sort: 1000,
        icon: <GrView />,
        depFn: ({ crudContext }) => crudContext.formContext.isEditable && crudContext.formContext.values?.id,
        size: 'middle',
        label: t('View', { ns: 'Core' }),
        onClick: () => {
            crudContext.actions.view(crudContext.formContext.values)
        },
    }
}
